export default __webpack_public_path__ + "static/media/facebook.836dbe3e.svg";